export const COMMISSIONING_TYPES = [
  { value: 'commissioning-comm-loop', labelKey: 'commissioning.commLoop' },
  { value: 'commissioning-circuit', labelKey: 'commissioning.circuit' },
  { value: 'commissioning-controller', labelKey: 'commissioning.controller' },
];

export const COMMISSIONING_TYPE_LABEL_MAP = Object.fromEntries(
  COMMISSIONING_TYPES.map(({ value, labelKey }) => [value, labelKey])
);

export const COMMISSIONING_STATUS_OPTIONS = [
  { value: 'pass', labelKey: 'common.pass' },
  { value: 'pass-with-notes', labelKey: 'common.passWithNotes' },
  { value: 'failed', labelKey: 'common.fail' },
];
